export enum SortingOption {
    ASC = "asc",
    DESC = "desc",
}